import React, { Component } from 'react'
import PlotlyGraph from './component/PlotlyGraph';
import queryString from 'query-string';
import './App.css';

export default class App extends Component {

  render() {
    const queryParams = queryString.parse(this.props.location.search);
    return (
      <div className="App container-fluid no-gutters px-0 text-smaller">
        <PlotlyGraph
          id={queryParams.id}
        />
      </div>
    );
  }
}
